import { Release } from '../models/release';

/**
 * Releases for mock mode and the e2e stubs.
 *
 * Two are Active on purpose: the releases page and the header switcher both list
 * every active release, ordered by start date (openOnUtc, falling back to
 * createdOnUtc). Titan is listed after Neptune here but starts before it and has no
 * openOnUtc, so anything that renders these in order has to sort rather than trust
 * the array — and the fallback gets exercised too.
 */
export const mockReleases: Release[] = [
  {
    releaseId: 1,
    releaseName: 'Neptune',
    releaseAzureId: 47315,
    rootSuiteAzureId: 1,
    status: 'Active',
    isActive: true,
    createdOnUtc: '2026-06-01T00:00:00Z',
    closedOnUtc: null,
    openOnUtc: '2026-06-01T00:00:00Z',
    signOffDueOnUtc: '2026-06-30T00:00:00Z',
    numberOfPassingTests: 30,
    numberOfFailingTests: 2,
    numberOfTests: 37,
    numberOfTestPlans: 4,
    numberOfTesters: 3,
    numberOfShowstoppers: 1,
    suites: [],
  },
  {
    releaseId: 4,
    releaseName: 'Titan',
    releaseAzureId: 50104,
    rootSuiteAzureId: 1,
    status: 'Active',
    isActive: true,
    createdOnUtc: '2026-05-11T00:00:00Z',
    closedOnUtc: null,
    // No open date configured, so this release starts on createdOnUtc.
    openOnUtc: null,
    signOffDueOnUtc: '2026-06-12T00:00:00Z',
    numberOfPassingTests: 12,
    numberOfFailingTests: 5,
    numberOfTests: 44,
    numberOfTestPlans: 3,
    numberOfTesters: 2,
    numberOfShowstoppers: 0,
    suites: [],
  },
  {
    releaseId: 2,
    releaseName: 'Pluto',
    releaseAzureId: 48222,
    rootSuiteAzureId: 1,
    status: 'Shipped',
    isActive: false,
    createdOnUtc: '2026-02-01T00:00:00Z',
    closedOnUtc: '2026-02-28T00:00:00Z',
    openOnUtc: '2026-02-01T00:00:00Z',
    signOffDueOnUtc: '2026-02-28T00:00:00Z',
    numberOfPassingTests: 96,
    numberOfFailingTests: 4,
    numberOfTests: 100,
    numberOfTestPlans: 6,
    numberOfTesters: 5,
    numberOfShowstoppers: 0,
    suites: [],
  },
  {
    releaseId: 3,
    releaseName: 'Great Smoky Mountains',
    releaseAzureId: 49559,
    rootSuiteAzureId: 1,
    status: 'Held',
    isActive: false,
    createdOnUtc: '2025-09-01T00:00:00Z',
    closedOnUtc: '2025-10-30T00:00:00Z',
    openOnUtc: '2025-09-14T00:00:00Z',
    signOffDueOnUtc: '2025-10-30T00:00:00Z',
    numberOfPassingTests: 80,
    numberOfFailingTests: 20,
    numberOfTests: 120,
    numberOfTestPlans: 8,
    numberOfTesters: 6,
    numberOfShowstoppers: 3,
    suites: [],
  },
];

/* ---- Scenario fixtures ----
   The number of active releases changes what the releases page and the header
   switcher render, so each state gets a named list that specs and e2e route
   overrides can serve instead of the default. */

/** More than one release active — the default list above. */
export const mockReleasesManyActive: Release[] = mockReleases;

/** Exactly one release active (Neptune), the way things looked before Titan. */
export const mockReleasesOneActive: Release[] = mockReleases.filter(
  (r) => !r.isActive || r.releaseId === 1,
);

/** Nothing active: history only, so no hero and no "Active" group in the switcher. */
export const mockReleasesNoActive: Release[] = mockReleases.filter((r) => !r.isActive);
